export default {
  en: {
    //stickfooter
    Home: "Home",
    Market: "Market",
    Trade: "Trade",
    Swapping: "Swapping",
    Funds: "Funds",
    //exchange
    Low: "Low",
    High: "High",
    Chart: "Chart",
    OrderBook: "Order Book",
    Trades: "Trades",
    Info: "Info",
    BaseAsset: "Base Asset",
    QuoteAsset: "Quote Asset",
    MinimumBuyVolume: "Minimum Buy Volume",
    MinimumSellVolume: "Minimum Sell Volume",
    CommissionBuy: "Commission Buy",
    CommissionSell: "Commission Sell",
    Status: "Status",
    Markets: "Markets",
    Connected: "Connected",
    Disconnect: "Disconnect",
    online: "online",
    Name: "Name",
    Vol: "Vol",
    LastPrice: "Last Price",
    hChg: "24h Chg%",
    avg: "avg.",
    HideOtherPairs: "Hide Other Pairs",
    CancelAll: "Cancel All",
    Cancel: "Cancel",
    Filled: "Filled",
    Fee: "Fee",
    OrderHistory: "Order History",
    Buy: "Buy",
    Sell: "Sell",
    OpenOrders: "Open Orders",
    Price: "Price",
    Total: "Total",
    MarketTrades: "Market Trades",
    Time: "Time",
    EditFavorite: "Edit Favorite",
    Done: "Done",
    Star: "Star",
    Rankings: "Rankings",
    Referral: "Referral",
    Chat: "Chat",
    PlaceOrder: "Place Order",
    DepthChart: "Depth Chart",
    CoinInfo: "Coin Info",
    //SwappingBox
    SwappingPlans: "Swapping Plans",
    MySwapping: "My Swapping",
    toget: "to get",
    in: "in",
    days: "days",
    InPeriod: "In Period",
    DailyProfit: "Daily Profit",
    MinSwap: "Minimum Swap",
    Available: "Available",
    Login: "Log in",
    or: "or",
    Register: "Register",
    toSwap: "to swap",
    Submit: "Submit",
    Transform: "Transform",
    CapitalSwap: "Capital Swap",
    Remaining: "Remaining",
    TotalProfit: "Total Profit",
    Rate: "Rate",
    Earn: "Earn",
    Staking: "Staking",
    toearn: "to earn",
    total: "total",
    dailyrewards: "daily rewards",
    Capitalreturnafter: "Capital return after",
    MinHoldings: "Minimum Holdings",
    Note: "Note",
    Conditions: "Conditions",
    MyInvest: "My Invest",
    MyEarnings: "My Earnings",
    note_staking:
      "Staking is the process of holding funds and grow your wealth with accruing interest.Deposit coins into Staking and start daily earning - it’s that simple!",
    note_swapping:
      "Before usage you should study the conditions and risk by yourself. Swapping box is the conversion from one thing to another, not a deposit, to exchange for coins, with the conversion time. Users can choose the used as appropriate and should study the usage by yourself to understand before use in order to know the conditions and risks including the value that may increase or decrease when considered well and can accept the conditions and risks and then use them.",
    //page
    TermsofService: "Terms of Service",
    PrivacyofPolicy: "Privacy of Policy",
    News: "News",
    Fees: "Fees",
    CoinsDetail: "Coins Detail",
    SystemStatus: "System Status",
    System: "System",
    //security
    Changepassword: "Change Password",
    GoogleAuthentication: "Google Authentication",
    ON: "ON",
    OFF: "OFF",
    DeviceManagement: "Device Management",
    //site
    helloworld: "Hello World",
    Alreadyhaveanaccount: "Already have an account",
    LogIn: "Log In",
    Confirm: "Confirm",
    Logintoyouraccount: "Login to your account",
    Needa365streamaccount: "Need a 365stream account",
    Createanaccount: "Create an account",
    Besureyouvisit: "Be sure you visit",
    Password: "Password",
    Forgotpassword: "Forgot password",
    Loading: "Loading",
    //user
    Receivewith: "Receive with",
    Generate: "Generate",
    forreceive: "for receive",
    PaymentURL: "Payment URL",
    Currency: "Currency",
    Email: "Email",
    Amount: "Amount",
    Account: "Account",
    SignOut: "Sign Out",
    SignIn: "Sign In",
    Security: "Security",
    Wallet: "Wallet",
    Transfer: "Transfer",
    Receive: "Receive",
    SwappingBox: "Swapping Box",
    AffiliateProgram: "Affiliate Program",
    AboutUs: "About Us",
    OurPartners: "Our Partners",
    Support: "Support",
    Language: "Language",
    About: "About",
    //wallet
    More: "More",
    SmallAssets: "Small Assets",
    AllAssets: "All Assets",
    Delisted: "Delisted",
    Balance: "Balance",
    GoToTrade: "Go To Trade",
    Deposit: "Deposit",
    Withdrawal: "Withdrawal",
    History: "History",
    Totalbalance: "Total balance",
    Inorder: "In order",
    Instaking: "In staking",
    Availablebalance: "Available balance",
    Transactions: "Transactions",
    DepositHistory: "Deposit History",
    WithdrawalHistory: "Withdrawal History",
    Withdraw: "Withdraw",
  },
  th: {
    //stickfooter
    Home: "หน้าแรก",
    Market: "ตลาด",
    Trade: "เทรด",
    Swapping: "การแปลง",
    Funds: "กระเป๋า",
    //exchange
    Low: "ต่ำสุด",
    High: "สูงสุด",
    Chart: "กราฟ",
    OrderBook: "Order Book",
    Trades: "การค้าล่าสุด",
    Info: "ข้อมูล",
    BaseAsset: "Base Asset",
    QuoteAsset: "Quote Asset",
    MinimumBuyVolume: "Minimum Buy Volume",
    MinimumSellVolume: "Minimum Sell Volume",
    CommissionBuy: "Commission Buy",
    CommissionSell: "Commission Sell",
    Status: "สถานะ",
    Markets: "ตลาดซื้อขาย",
    Connected: "เชื่อมต่อ",
    Disconnect: "ตัดขาด",
    online: "ออนไลน์",
    Name: "คู่เหรียญ",
    Vol: "ปริมาณ",
    LastPrice: "ราคาล่าสุด",
    hChg: "24h Chg%",
    avg: "เฉลี่ย",
    HideOtherPairs: "ซ่อนคู่อื่น",
    CancelAll: "ยกเลิกทั้งหมด",
    Cancel: "ยกเลิก",
    Filled: "สำเร็จ",
    Fee: "ค่าธรรมเนียม",
    OrderHistory: "ประวัติการสั่งซื้อ",
    Buy: "ซื้อ",
    Sell: "ขาย",
    OpenOrders: "ออเดอร์ที่เปิด",
    Price: "ราคา",
    Total: "ทั้งหมด",
    MarketTrades: "การค้าล่าสุด",
    Time: "เวลา",
    EditFavorite: "เลือกคู่เทรดที่โปรด",
    Done: "เสร็จ",
    Star: "ดาว",
    Rankings: "จัดอันดับ",
    Referral: "ชวนเพื่อน",
    Chat: "พูดคุย",
    PlaceOrder: "สั่งคำสั่ง ซื้อ-ขาย",
    DepthChart: "Depth Chart",
    CoinInfo: "ข้อมูลเหรียญ",
    //SwappingBox
    SwappingPlans: "แผนการแปลง",
    MySwapping: "การแปลงของคุณ",
    toget: "เพื่อรับ",
    in: "ใน",
    days: "วัน",
    InPeriod: "ระยะเวลา",
    DailyProfit: "ผลตอบแทนต่อวัน",
    MinSwap: "แปลงขั้นต่ำ",
    Available: "ได้อีก",
    Login: "เข้าระบบ",
    or: "หรือ",
    Register: "สมัครสมาชิก",
    toSwap: "เพื่อแปลง",
    Submit: "ยืนยัน",
    Transform: "แปลงจาก",
    CapitalSwap: "ต้นทุน",
    Remaining: "ซึ่งเหลืออยู่",
    TotalProfit: "กำไรทั้งหมด",
    Rate: "เรท",
    Earn: "รายได้",
    Staking: "ออมเหรียญ",
    toearn: "ได้รับ",
    total: "รวม",
    dailyrewards: "ในทุกๆวัน",
    Capitalreturnafter: "คืนทุนหลังจาก",
    MinHoldings: "จำนวนขั้นต่ำ",
    Note: "หมายเหตุ",
    Conditions: "เงื่อนไข",
    MyInvest: "การลงทุนของฉัน",
    MyEarnings: "รายได้ของฉัน",
    note_staking:
      "การออมเงินเป็นกระบวนการในการถือครองเงินทุนและเพิ่มความมั่งคั่งของคุณด้วยการรับดอกเบี้ยฝากเงินเข้าสู่การออมเงินและเริ่มสร้างรายได้ทุกวัน - มันง่ายมาก!",
    note_swapping:
      "ก่อนใช้งานควรศึกษาเงื่อนไขและความเสี่ยงด้วยตัวเอง Swapping box คือ การแปลงเปลี่ยนจากสิ่งนึงเป็นอีกสิ่งนึง ไม่ใช่การฝาก เป็นการเเปลงเหรียญโดยมีระยะเวลาในการเเปลง ผู้ใช้สามารถเลือก ที่จะใช้งานได้ตามความเหมาะสมและควรศึกษาการใช้งานด้วยตัวเองให้เข้าใจก่อนเข้าใช้งานเพื่อให้ทราบถึงเงื่อนไขและความเสี่ยงรวมไปถึงมูลค่าที่อาจจะเพิ่มขึ้นหรือลดลงเมื่อพิจารณาดีแล้วและสามารถยอมรับเงื่อนไขและความเสี่ยงได้แล้วจึงค่อยใช้งาน",
    //page
    TermsofService: "เงื่อนไขการให้บริการ",
    PrivacyofPolicy: "นโยบายความเป็นส่วนตัว",
    News: "ข่าวสาร",
    Fees: "ค่าธรรมเนียม",
    CoinsDetail: "รายละเอียดเหรียญ",
    SystemStatus: "สถานะระบบ",
    System: "ระบบ",
    //security
    Changepassword: "เปลี่ยนรหัสผ่าน",
    GoogleAuthentication: "Google Authentication",
    ON: "เปิด",
    OFF: "ปิด",
    DeviceManagement: "การจัดการอุปกรณ์",
    //site
    helloworld: "สวัสดีชาวโลก",
    Alreadyhaveanaccount: "มีบัญชีแล้ว",
    LogIn: "เข้าระบบ",
    Confirm: "ยืนยัน",
    Logintoyouraccount: "เข้าระบบบัญชีของคุณ",
    Needa365streamaccount: "ต้องการเปิดบัญชี",
    Createanaccount: "สมัคร",
    Besureyouvisit: "โปรดแน่ใจว่าลิ้งถูกต้อง",
    Password: "รหัสผ่าน",
    Forgotpassword: "ลืมรหัสผ่าน",
    Loading: "กำลังโหลด",
    //user
    Receivewith: "รับเงินโดย",
    Generate: "สร้าง",
    forreceive: "สำหรับรับเงิน",
    PaymentURL: "ชำระผ่านลิ้ง",
    Currency: "สกุลเงิน",
    Email: "อีเมล",
    Amount: "จำนวน",
    Account: "บัญชี",
    SignOut: "ออกจากระบบ",
    SignIn: "เข้าระบบ",
    Security: "ความปลอดภัย",
    Wallet: "กระเป๋า",
    Transfer: "โอนเงิน",
    Receive: "ได้รับ",
    SwappingBox: "กล่องแลกเปลี่ยน",
    AffiliateProgram: "โปรแกรมแนะนำสมาชิก",
    AboutUs: "เกี่ยวกับเรา",
    OurPartners: "พันธมิตรของเรา",
    Support: "ทีมดูแล",
    Language: "ภาษา",
    About: "เกี่ยวกับ",
    //wallet
    More: "เพิ่มเติม",
    SmallAssets: "สินทรัพย์ขนาดเล็ก",
    AllAssets: "สินทรัพย์ทั้งหมด",
    Delisted: "เพิกถอน",
    //wallet
    Balance: "ยอดเงิน",
    GoToTrade: "ไปหน้าเทรด",
    Deposit: "ฝากเงิน",
    Withdrawal: "ถอนเงิน",
    History: "ประวัติ",
    Totalbalance: "ยอดเงินรวม",
    Inorder: "แสดงออเดอร์เปิด",
    Instaking: "ยอดที่ออมเหรียญ",
    Availablebalance: "ยอดคงเหลือที่ใช้ได้",
    Transactions: "การทำธุรกรรม",
    DepositHistory: "ประวัติการฝาก",
    WithdrawalHistory: "ประวัติการถอน",
    Withdraw: "ถอนเงิน",
  },
  ko: {
    //stickfooter
    Home: "집",
    Market: "시장",
    Trade: "무역",
    Swapping: "스와핑",
    Funds: "자금",
    //exchange
    Low: "낮은",
    High: "높은",
    Chart: "차트",
    OrderBook: "주문서",
    Trades: "거래",
    Info: "정보",
    BaseAsset: "기본 자산",
    QuoteAsset: "자산 견적",
    MinimumBuyVolume: "최소 구매량",
    MinimumSellVolume: "최소 판매량",
    CommissionBuy: "커미션 구매",
    CommissionSell: "커미션 판매",
    Status: "지위",
    Markets: "시장",
    Connected: "연결됨",
    Disconnect: "분리",
    online: "온라인",
    Name: "이름",
    Vol: "권",
    LastPrice: "마지막 가격",
    hChg: "24h Chg%",
    avg: "avg.",
    HideOtherPairs: "다른 쌍 숨기기",
    CancelAll: "모두 취소",
    Cancel: "취소",
    Filled: "채우는",
    Fee: "보수",
    OrderHistory: "주문 내역",
    Buy: "사다",
    Sell: "팔다",
    OpenOrders: "주문 열기",
    Price: "가격",
    Total: "합계",
    MarketTrades: "시장 거래",
    Time: "시각",
    EditFavorite: "즐겨 찾기 편집",
    Done: "끝난",
    Star: "별",
    Rankings: "랭킹",
    Referral: "추천",
    Chat: "잡담",
    PlaceOrder: "주문",
    DepthChart: "깊이 차트",
    CoinInfo: "코인 정보",
    //SwappingBox
    SwappingPlans: "스와핑 계획",
    MySwapping: "내 스와핑",
    toget: "얻을",
    in: "...에서",
    days: "일",
    InPeriod: "시대에",
    DailyProfit: "일일 이익",
    MinSwap: "최소. 교환",
    Available: "유효한",
    Login: "로그인",
    or: "또는",
    Register: "레지스터",
    toSwap: "교환하다",
    Submit: "제출",
    Transform: "변환",
    CapitalSwap: "자본 교환",
    Remaining: "남은",
    TotalProfit: "총 이윤",
    Rate: "율",
    Earn: "벌다",
    Staking: "스트라이크",
    toearn: "벌다",
    total: "합계",
    dailyrewards: "일일 보상",
    Capitalreturnafter: "후 반환",
    MinHoldings: "최소 보유",
    Note: "노트",
    Conditions: "정황",
    MyInvest: "내 투자",
    MyEarnings: "내 수입",
    note_staking:
      "스태킹은 자금을 보유하고이자를 발생시켜 부를 키우는 과정입니다. 코인을 스태킹에 입금하고 매일 수익을 올리십시오. 아주 간단합니다!",
    note_swapping:
      "사용하기 전에 스스로 조건과 위험을 연구해야합니다. 스와핑 박스는 전환 시간과 함께 동전을 교환하기 위해 예금이 아닌 다른 것으로 변환하는 것입니다. 사용자는 적절하게 사용을 선택하고 잘 고려할 때 증가 또는 감소 할 수있는 값을 포함하여 조건 및 위험을 파악하고 조건 및 위험을 수용 한 다음이를 사용할 수 있도록 사용하기 전에 이해하기 위해 사용 방법을 스스로 연구해야합니다.",
    //page
    TermsofService: "서비스 약관",
    PrivacyofPolicy: "정책의 프라이버시",
    News: "뉴스",
    Fees: "수수료",
    CoinsDetail: "동전 상세",
    SystemStatus: "시스템 상태",
    System: "체계",
    //security
    Changepassword: "비밀번호 변경",
    GoogleAuthentication: "구글 인증",
    ON: "에",
    OFF: "떨어져서",
    DeviceManagement: "장치 관리",
    //site
    helloworld: "Hello World",
    Alreadyhaveanaccount: "이미 계정이 있습니다",
    LogIn: "로그인",
    Confirm: "확인",
    Logintoyouraccount: "계정에 로그인",
    Needa365streamaccount: "365stream 계정이 필요합니다",
    Createanaccount: "계정 만들기",
    Besureyouvisit: "방문하십시오",
    Password: "암호",
    Forgotpassword: "비밀번호를 잊으 셨나요",
    Loading: "로딩",
    //user
    Receivewith: "수신",
    Generate: "일으키다",
    forreceive: "받기 위해",
    PaymentURL: "결제 URL",
    Currency: "통화",
    Email: "이메일",
    Amount: "양",
    Account: "계정",
    SignOut: "로그 아웃",
    SignIn: "로그인",
    Security: "보안",
    Wallet: "지갑",
    Transfer: "이전",
    Receive: "받다",
    SwappingBox: "스와핑 박스",
    AffiliateProgram: "제휴 프로그램",
    AboutUs: "회사 소개",
    OurPartners: "우리의 파트너들",
    Support: "지원하다",
    Language: "언어",
    About: "약",
    //wallet
    More: "더",
    SmallAssets: "작은 자산",
    AllAssets: "모든 자산",
    Delisted: "상장 폐지",
    Balance: "균형",
    GoToTrade: "무역으로 이동",
    Deposit: "예금",
    Withdrawal: "철수",
    History: "역사",
    Totalbalance: "전체 균형",
    Inorder: "순서대로",
    Instaking: "스테이 킹 중",
    Availablebalance: "사용 가능한 잔액",
    Transactions: "업무",
    DepositHistory: "예금 내역",
    WithdrawalHistory: "철회 내역",
    Withdraw: "빼다",
  },
  jp: {
    //stickfooter
    Home: "ホーム",
    Market: "市場",
    Trade: "トレード",
    Swapping: "スワッピング",
    Funds: "資金",
    //exchange
    Low: "低い",
    High: "高い",
    Chart: "チャート",
    OrderBook: "オーダーブック",
    Trades: "取引",
    Info: "情報",
    BaseAsset: "基本資産",
    QuoteAsset: "見積資産",
    MinimumBuyVolume: "最低購入量",
    MinimumSellVolume: "最低販売量",
    CommissionBuy: "コミッション購入",
    CommissionSell: "手数料売り",
    Status: "状態",
    Markets: "市場",
    Connected: "接続済み",
    Disconnect: "切断する",
    online: "オンライン",
    Name: "名",
    Vol: "巻",
    LastPrice: "最終価格",
    hChg: "24h Chg%",
    avg: "avg.",
    HideOtherPairs: "他のペアを非表示",
    CancelAll: "すべてキャンセル",
    Cancel: "キャンセル",
    Filled: "いっぱい",
    Fee: "費用",
    OrderHistory: "注文履歴",
    Buy: "購入",
    Sell: "売る",
    OpenOrders: "未処理の注文",
    Price: "価格",
    Total: "合計",
    MarketTrades: "市場取引",
    Time: "時間",
    EditFavorite: "お気に入りを編集",
    Done: "完了",
    Star: "星",
    Rankings: "ランキング",
    Referral: "紹介",
    Chat: "チャット",
    PlaceOrder: "注文する",
    DepthChart: "深度チャート",
    CoinInfo: "コイン情報",
    //SwappingBox
    SwappingPlans: "交換計画",
    MySwapping: "私のスワッピング",
    toget: "取得するため",
    in: "に",
    days: "日々",
    InPeriod: "期間中",
    DailyProfit: "毎日の利益",
    MinSwap: "ミン。スワップ",
    Available: "利用可能",
    Login: "ログイン",
    or: "または",
    Register: "登録",
    toSwap: "交換します",
    Submit: "提出する",
    Transform: "変換する",
    CapitalSwap: "キャピタルスワップ",
    Remaining: "残り",
    TotalProfit: "利益総額",
    Rate: "レート",
    Earn: "稼ぐ",
    Staking: "ストライク",
    toearn: "稼ぐ",
    total: "合計",
    dailyrewards: "毎日の報酬",
    Capitalreturnafter: "後に戻る",
    MinHoldings: "最低保有数",
    Note: "注意",
    Conditions: "条件",
    MyInvest: "私の投資",
    MyEarnings: "私の収益",
    note_staking:
      "ステーキングとは、資金を保有し、関心を集めて富を増やすプロセスです。コインをステーキングに預け入れて、毎日の収益を開始しましょう。",
    note_swapping:
      "使用する前に、自分で状態とリスクを調べる必要があります。スワッピングボックスとは、コインを交換するための、預金時間ではなく、あるものから別のものへの変換です。ユーザーは必要に応じて使用するものを選択することができます。使用前に使用方法を調べて使用前に理解し、よく考えられたときに増加または減少する可能性のある値を含む条件とリスクを把握し、条件とリスクを受け入れて使用することができます。",
    //page
    TermsofService: "利用規約",
    PrivacyofPolicy: "ポリシーのプライバシー",
    News: "ニュース",
    Fees: "料金",
    CoinsDetail: "コインの詳細",
    SystemStatus: "システムステータス",
    System: "システム",
    //security
    Changepassword: "パスワードを変更する",
    GoogleAuthentication: "Google認証",
    ON: "に",
    OFF: "オフ",
    DeviceManagement: "端末管理",
    //site
    helloworld: "こんにちは世界",
    Alreadyhaveanaccount: "すでにアカウントをお持ちですか",
    LogIn: "ログイン",
    Confirm: "確認する",
    Logintoyouraccount: "あなたのアカウントにログイン",
    Needa365streamaccount: "365streamアカウントが必要です",
    Createanaccount: "アカウントを作成する",
    Besureyouvisit: "必ず訪問してください",
    Password: "パスワード",
    Forgotpassword: "パスワードをお忘れですか",
    Loading: "読み込み中",
    //user
    Receivewith: "で受け取る",
    Generate: "生成する",
    forreceive: "受信用",
    PaymentURL: "支払いURL",
    Currency: "通貨",
    Email: "Eメール",
    Amount: "量",
    Account: "アカウント",
    SignOut: "サインアウト",
    SignIn: "サインイン",
    Security: "セキュリティ",
    Wallet: "財布",
    Transfer: "転送",
    Receive: "受け取る",
    SwappingBox: "交換ボックス",
    AffiliateProgram: "アフィリエイトプログラム",
    AboutUs: "私たちに関しては",
    OurPartners: "当社のパートナー",
    Support: "サポート",
    Language: "言語",
    About: "約",
    //wallet
    More: "もっと",
    SmallAssets: "小さな資産",
    AllAssets: "すべての資産",
    Delisted: "上場廃止",
    Balance: "バランス",
    GoToTrade: "取引に行く",
    Deposit: "保証金",
    Withdrawal: "撤退",
    History: "歴史",
    Totalbalance: "総合収支",
    Inorder: "順番に",
    Instaking: "ステーキングで",
    Availablebalance: "利用可能残高",
    Transactions: "取引",
    DepositHistory: "入金履歴",
    WithdrawalHistory: "出金履歴",
    Withdraw: "撤回",
  },
  zhcn: {
    //stickfooter
    Home: "家",
    Market: "市场",
    Trade: "贸易方式",
    Swapping: "交换",
    Funds: "资金",
    //exchange
    Low: "低",
    High: "高",
    Chart: "图表",
    OrderBook: "订单簿",
    Trades: "交易",
    Info: "信息",
    BaseAsset: "基础资产",
    QuoteAsset: "报价资产",
    MinimumBuyVolume: "最小购买量",
    MinimumSellVolume: "最小销售量",
    CommissionBuy: "佣金购买",
    CommissionSell: "佣金出售",
    Status: "状态",
    Markets: "市场",
    Connected: "连接的",
    Disconnect: "断开",
    online: "线上",
    Name: "名称",
    Vol: "卷",
    LastPrice: "最后价格",
    hChg: "24h Chg%",
    avg: "avg.",
    HideOtherPairs: "隐藏其他对",
    CancelAll: "全部取消",
    Cancel: "取消",
    Filled: "填充",
    Fee: "费用",
    OrderHistory: "订单历史",
    Buy: "购买",
    Sell: "卖",
    OpenOrders: "未结订单",
    Price: "价钱",
    Total: "总",
    MarketTrades: "市场交易",
    Time: "时间",
    EditFavorite: "编辑收藏",
    Done: "完成了",
    Star: "星",
    Rankings: "排名",
    Referral: "转介",
    Chat: "聊天室",
    PlaceOrder: "下订单",
    DepthChart: "深度图",
    CoinInfo: "硬币信息",
    //SwappingBox
    SwappingPlans: "交换计划",
    MySwapping: "我的交换",
    toget: "要得到",
    in: "在",
    days: "天",
    InPeriod: "在期间",
    DailyProfit: "每日利润",
    MinSwap: "Min. Swap",
    Available: "可用的",
    Login: "登录",
    or: "要么",
    Register: "寄存器",
    toSwap: "交换",
    Submit: "提交",
    Transform: "转变",
    CapitalSwap: "资本互换",
    Remaining: "剩余的",
    TotalProfit: "总利润",
    Rate: "率",
    Earn: "赚",
    Staking: "罢工",
    toearn: "赚",
    total: "总",
    dailyrewards: "每日奖励",
    Capitalreturnafter: "之后返回",
    MinHoldings: "最低持股",
    Note: "注意",
    Conditions: "条件",
    MyInvest: "我的投资",
    MyEarnings: "我的收入",
    note_staking:
      "放样是持有资金并通过累积利息来增长财富的过程。将硬币存入放样并开始每日收入-就是这么简单！",
    note_swapping:
      "使用前，您应该自己研究情况和风险。交换框是指从一件事到另一件事的转换，而不是定金，要用转换时间来交换硬币。用户可以适当选择使用方法，并应在使用前自行研究使用方法，以了解条件和风险，包括在合理考虑后可能增加或减少的价值，并接受条件和风险然后再使用它们。",
    //page
    TermsofService: "服务条款",
    PrivacyofPolicy: "政策隐私",
    News: "新闻",
    Fees: "费用",
    CoinsDetail: "硬币细节",
    SystemStatus: "系统状况",
    System: "系统",
    //security
    Changepassword: "更改密码",
    GoogleAuthentication: "Google认证",
    ON: "上",
    OFF: "关",
    DeviceManagement: "设备管理",
    //site
    helloworld: "你好，世界",
    Alreadyhaveanaccount: "已经有一个帐号",
    LogIn: "登录",
    Confirm: "确认",
    Logintoyouraccount: "登录到您的帐户",
    Needa365streamaccount: "需要一个365stream帐户",
    Createanaccount: "创建一个帐户",
    Besureyouvisit: "确保您访问",
    Password: "密码",
    Forgotpassword: "忘记密码",
    Loading: "载入中",
    //user
    Receivewith: "接收",
    Generate: "生成",
    forreceive: "接收",
    PaymentURL: "付款网址",
    Currency: "货币",
    Email: "电子邮件",
    Amount: "量",
    Account: "帐户",
    SignOut: "登出",
    SignIn: "登入",
    Security: "安全",
    Wallet: "钱包",
    Transfer: "传递",
    Receive: "接收",
    SwappingBox: "交换盒",
    AffiliateProgram: "会员计划",
    AboutUs: "关于我们",
    OurPartners: "我们的合作伙伴",
    Support: "支持",
    Language: "语言",
    About: "关于",
    //wallet
    More: "更多",
    SmallAssets: "小资产",
    AllAssets: "所有资产",
    Delisted: "退市",
    Balance: "平衡",
    GoToTrade: "去交易",
    Deposit: "存款",
    Withdrawal: "退出",
    History: "历史",
    Totalbalance: "总余额",
    Inorder: "为了",
    Instaking: "放样",
    Availablebalance: "可用余额",
    Transactions: "交易次数",
    DepositHistory: "存款记录",
    WithdrawalHistory: "提款历史",
    Withdraw: "退出",
  },
};
